import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _class, _FileUploadEdit;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Checkbox } from '@instructure/ui-checkbox';
import { TextInput, FormFieldGroup } from '@instructure/quiz-common';
import NumberInput from '@instructure/quiz-number-input';
import FileUploadInteractionType from '../../../records/interactions/file_upload';
import QuestionContainer from '../../common/edit/components/QuestionContainer';
import QuestionSettingsContainer from '../../common/edit/components/QuestionSettingsContainer';
import withEditTools from '../../../util/withEditTools';
import t from '@instructure/quiz-i18n/es/format-message';
import QuestionSettingsPanel from '../../common/edit/components/QuestionSettingsPanel';
import CalculatorOptionWithOqaatAlert from '../../common/edit/components/CalculatorOptionWithOqaatAlert';

/**
---
category: FileUpload
---

  File Upload Edit component

  ```jsx_example
  function Example (props) {
    const exampleProps = {
      itemBody: 'Give two examples of tortoises',
      interactionData: {
        restrictCount: true,
        filesCount: '2'
      },
      overrideEditableForRegrading: false,
      properties: {
        restrictTypes: true,
        allowedTypes: 'media/*'
      }
    }

    return (
      <FileUploadEdit {...exampleProps} {...props} />
    )
  }

  <SettingsSwitcher locales={LOCALES}>
    <EditStateProvider>
      <Example />
    </EditStateProvider>
  </SettingsSwitcher>
  ```
**/
var FileUploadEdit = withEditTools(_class = (_FileUploadEdit = /*#__PURE__*/function (_Component) {
  function FileUploadEdit() {
    var _this;
    _classCallCheck(this, FileUploadEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FileUploadEdit, [].concat(args));
    _defineProperty(_this, "handleCalculatorTypeChange", function (e, value) {
      _this.props.changeItemState({
        calculatorType: value
      });
    });
    _defineProperty(_this, "handleRestrictCountChange", function () {
      return _this.props.changeItemState({
        interactionData: _objectSpread(_objectSpread({}, _this.props.interactionData), {}, {
          restrictCount: !_this.props.interactionData.restrictCount
        })
      });
    });
    _defineProperty(_this, "handleFilesCountChange", function (event, countString, normalizedCountString) {
      return _this.props.changeItemState({
        interactionData: _objectSpread(_objectSpread({}, _this.props.interactionData), {}, {
          filesCount: normalizedCountString
        })
      });
    });
    _defineProperty(_this, "handleRestrictTypesChange", function (event) {
      return _this.props.changeItemState({
        properties: _objectSpread(_objectSpread({}, _this.props.properties), {}, {
          restrictTypes: event.target.checked
        })
      });
    });
    _defineProperty(_this, "handleAllowedTypesChange", function (event) {
      return _this.props.changeItemState({
        properties: _objectSpread(_objectSpread({}, _this.props.properties), {}, {
          allowedTypes: event.target.value
        })
      });
    });
    return _this;
  }
  _inherits(FileUploadEdit, _Component);
  return _createClass(FileUploadEdit, [{
    key: "renderOptions",
    value: function renderOptions() {
      var _this$props$propertie = this.props.properties,
        restrictTypes = _this$props$propertie.restrictTypes,
        allowedTypes = _this$props$propertie.allowedTypes;
      var _this$props$interacti = this.props.interactionData,
        restrictCount = _this$props$interacti.restrictCount,
        filesCount = _this$props$interacti.filesCount;
      var allowedTypesDescription = t('File extensions');
      var filesCountDescription = t('Max number of files');
      var description = /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('File upload options'));
      var fieldGroup = /*#__PURE__*/React.createElement(FormFieldGroup, {
        rowSpacing: "small",
        description: description
      }, /*#__PURE__*/React.createElement(CalculatorOptionWithOqaatAlert, {
        disabled: this.props.overrideEditableForRegrading,
        calculatorValue: this.props.calculatorType,
        onCalculatorTypeChange: this.handleCalculatorTypeChange,
        oqaatChecked: this.props.oneQuestionAtATime,
        onOqaatChange: this.props.setOneQuestionAtATime
      }), /*#__PURE__*/React.createElement(Checkbox, {
        disabled: this.props.overrideEditableForRegrading,
        checked: restrictCount,
        label: t('Limit File number'),
        onChange: this.handleRestrictCountChange,
        value: "restrictCount",
        "data-automation": "sdk-limit-file-number-checkbox"
      }), restrictCount && /*#__PURE__*/React.createElement(NumberInput, {
        disabled: this.props.overrideEditableForRegrading,
        renderLabel: /*#__PURE__*/React.createElement(ScreenReaderContent, null, filesCountDescription),
        messages: this.props.getErrors('interactionData.filesCount'),
        min: 1,
        onChange: this.handleFilesCountChange,
        placeholder: filesCountDescription,
        value: filesCount,
        "data-automation": "sdk-limit-file-number-input"
      }), /*#__PURE__*/React.createElement(Checkbox, {
        checked: restrictTypes,
        disabled: this.props.overrideEditableForRegrading,
        label: t('Restrict File Types'),
        onChange: this.handleRestrictTypesChange,
        value: "restrictTypes",
        "data-automation": "sdk-restrict-file-type-checkbox"
      }), restrictTypes && /*#__PURE__*/React.createElement(TextInput, {
        interaction: this.props.overrideEditableForRegrading ? 'disabled' : 'enabled',
        renderLabel: /*#__PURE__*/React.createElement(ScreenReaderContent, null, allowedTypesDescription),
        messages: [].concat(_toConsumableArray(this.props.getErrors('properties.allowedTypes')), [{
          text: t('Enter file extensions separated by a comma'),
          type: 'hint'
        }]),
        onChange: this.handleAllowedTypesChange,
        placeholder: allowedTypesDescription,
        type: "text",
        value: allowedTypes,
        "data-automation": "sdk-file-extensions-input"
      }));
      return /*#__PURE__*/React.createElement(QuestionSettingsContainer, {
        additionalOptions: this.props.additionalOptions
      }, /*#__PURE__*/React.createElement(QuestionSettingsPanel, {
        label: t('Options'),
        defaultExpanded: true
      }, fieldGroup));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuestionContainer, {
        disabled: this.props.overrideEditableForRegrading,
        enableRichContentEditor: this.props.enableRichContentEditor,
        itemBody: this.props.itemBody,
        onDescriptionChange: this.props.onDescriptionChange,
        onModalClose: this.props.onModalClose,
        onModalOpen: this.props.onModalOpen,
        openImportModal: this.props.openImportModal,
        stemErrors: this.props.getErrors('itemBody')
      }), this.renderOptions());
    }
  }]);
}(Component), _defineProperty(_FileUploadEdit, "interactionType", FileUploadInteractionType), _defineProperty(_FileUploadEdit, "propTypes", _objectSpread({
  additionalOptions: PropTypes.array,
  calculatorType: PropTypes.string,
  changeItemState: PropTypes.func,
  enableRichContentEditor: PropTypes.bool,
  interactionData: PropTypes.shape({
    restrictCount: PropTypes.bool.isRequired,
    filesCount: PropTypes.string.isRequired
  }).isRequired,
  itemBody: PropTypes.string.isRequired,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  oneQuestionAtATime: PropTypes.bool,
  openImportModal: PropTypes.func,
  overrideEditableForRegrading: PropTypes.bool,
  properties: PropTypes.shape({
    restrictTypes: PropTypes.bool.isRequired,
    allowedTypes: PropTypes.string
  }).isRequired,
  setOneQuestionAtATime: PropTypes.func
}, withEditTools.injectedProps)), _defineProperty(_FileUploadEdit, "defaultProps", {
  additionalOptions: [],
  calculatorType: 'none',
  enableRichContentEditor: true,
  oneQuestionAtATime: false,
  overrideEditableForRegrading: false,
  setOneQuestionAtATime: Function.prototype,
  changeItemState: void 0,
  onModalClose: void 0,
  onModalOpen: void 0,
  openImportModal: void 0
}), _FileUploadEdit)) || _class;
export { FileUploadEdit as default };